// Query keys for the Account entity — one source so invalidation stays in sync.

export const ACCOUNT_KEYS = {
  all: ['account'] as const,
  current: () => [...ACCOUNT_KEYS.all, 'current'] as const,
} as const;
